import React from "react";
import EngineClusterPage from "../../../../components/pages/_new/super/engines/EngineClusterPage";

const BmClusterPage = () => <EngineClusterPage engineType="BM_ENGINE" />;

export default BmClusterPage;
